module.exports = __webpack_public_path__ + "static/media/faleConosco.a5123094.svg";